import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'

import { Observable, map } from 'rxjs'

import { ApiHttpService } from '@flowx/designer/shared/api/api-http.service'

import { ExportNotificationDetails } from '../notifications-payload.model'
import { UserNotificationEvent } from '../notifications.model'

interface UserNotificationsResponse {
  userNotifications: UserNotificationEvent[]
}

/** `details` is null for a notification that has none. */
interface UserNotificationDetailsResponse {
  details: ExportNotificationDetails | null
}

/** The designer-user service's notification endpoints, reached through its `designer-user` ingress prefix. */
@Injectable({ providedIn: 'root' })
export class NotificationsCenterApi extends ApiHttpService {
  constructor() {
    const baseUrl = inject<string>('BASE_URL' as any)
    const httpClient = inject(HttpClient)
    super(`${baseUrl}/designer-user/api`, httpClient)
  }

  getNotifications(): Observable<UserNotificationEvent[]> {
    return this.get('notifications').pipe(
      map(({ userNotifications }: UserNotificationsResponse) => userNotifications)
    )
  }

  markAsRead(notificationId: string): Observable<void> {
    return this.patch(`notifications/${notificationId}/mark-read`, {})
  }

  markAllAsRead(): Observable<void> {
    return this.patch('notifications/mark-all-read', {})
  }

  getNotificationDetails(notificationId: string): Observable<ExportNotificationDetails | null> {
    return this.get(`notifications/${notificationId}/details`).pipe(
      map(({ details }: UserNotificationDetailsResponse) => details)
    )
  }
}
